import React from 'react';
import Assets from '../Assets';

function AssetsPage() {
    return (
        <Assets />
    );
}

export default AssetsPage;